export * from './questionario-juridico';